import { takeEvery, put, select, call } from 'redux-saga/effects'
import actionTypes from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError, showSuccess } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'
import { ORG_INACTIVE_NOTIFICATION_DELETE_SUCCESS } from 'app/constants/toastrMessages'

export default function* deleteSaga() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.DELETE.REQUEST, handleDeleteRequest)
}

export function* handleDeleteRequest() {
  try {
    const id = yield select(selectors.getIdToDelete)
    if (id === null) {
      return
    }
    const pending = yield select(selectors.getPendingDelete)
    if (!pending) {
      yield put(actions.setPending('delete', true))
      yield put(actions.orgInactiveNotifications.delete.success(id))
      const orgId = yield select(getViewOrganizationSettingsId)
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/${id}`, { method: 'DELETE' })
      const list = yield select(selectors.getList)
      const orders = list.map((notification, index) => ({ order: index + 1, id: notification.get('id') }))
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/set-order`, {
        method: 'POST',
        data: { orders },
      })
      showSuccess({ content: ORG_INACTIVE_NOTIFICATION_DELETE_SUCCESS })
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.delete.fail(error))
  }
}
